export { default as CourseCard } from "./CourseCard"
